import FormDialog from './FormDialog';

export default FormDialog;
